import React from 'react'
import { TooltipDescription } from './styles'
import { Tooltip } from '~/components/shared/tooltip'

export interface TimelineTooltipEnclosedProps {
  children: React.ReactNode
  description: string
}

export const TimelineTooltipEnclosed = ({ children, description }: TimelineTooltipEnclosedProps): JSX.Element => {
  if (!description || !children) return <></>

  return (
    <Tooltip
      cursor="pointer"
      description={<TooltipDescription>{description}</TooltipDescription>}
      opacity={0.8}
      delay={0}
    >
      {children}
    </Tooltip>
  )
}
